import { render } from "./textScrolling.vue?vue&type=template&id=74049813&scoped=true"
import script from "./textScrolling.vue?vue&type=script&lang=js"
export * from "./textScrolling.vue?vue&type=script&lang=js"

import "./textScrolling.vue?vue&type=style&index=0&id=74049813&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74049813"]])

export default __exports__